import { useEffect, useState } from 'react';
import styled from 'styled-components';
import config from '../../config/config.json';
import { POCCard } from '../../components/POC/POCCard';
import augentLogo from '../../assets/AugentColor.svg';
import { clearAppSession, getAuthProvider, isAuthenticated, syncSessionFromServer } from '../../auth-utils';
import { logoutFromMicrosoft, logoutLocalSession } from '../../services/authService';

const DashboardContainer = styled.div`
  padding: 0rem 16px;
  font-family: 'Segoe UI', sans-serif;
  // background-color: #f9fafb;
  min-height: 100vh;
  text-align: center;
  max-width: 1280px;
  margin: 0 auto;
`;

const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 10;
  // background-color: #f9fafb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 2rem;
  // width: 100%;
  // box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;

  h1 {
    margin-left: 1rem;
    font-size: 1.8rem;
    color: #111827;
  }
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const LogoutButton = styled.button`
  background: #ef4444;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background: #dc2626;
  }
`;

const POCGrid = styled.div`
display: flex;
flex-direction: row;
justify-content: center;
flex-wrap: wrap;
gap: 2rem;
margin-top: 2rem;
`;

const Heading = styled.h1`
  color: #6b21a8; /* purple-800 */
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const Logo = styled.img`
    padding: 8px 10px;
    will-change: filter;
    transition: filter .3s;
`;

export const DashboardPage = () => {
  const [sessionExpiry, setSessionExpiry] = useState<number | null>(null);
  const [timeRemaining, setTimeRemaining] = useState<string>('');

  useEffect(() => {
    const checkAuth = async () => {
      if (!isAuthenticated()) {
        const restored = await syncSessionFromServer();
        if (!restored) {
          clearAppSession();
        }
        return false;
      }

      const serverSessionOk = await syncSessionFromServer();
      if (!serverSessionOk) {
        clearAppSession();
        return false;
      }

      const expiry = localStorage.getItem('sessionExpiry');
      if (expiry) {
        setSessionExpiry(parseInt(expiry, 10));
      }

      return true;
    };

    void checkAuth();
    const authInterval = setInterval(() => {
      void checkAuth();
    }, 60000);

    return () => {
      clearInterval(authInterval);
    };
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      if (sessionExpiry) {
        const remaining = sessionExpiry - Date.now();
        if (remaining <= 0) {
          clearAppSession();
          return;
        }

        const hours = Math.floor(remaining / (1000 * 60 * 60));
        const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

        setTimeRemaining(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [sessionExpiry]);

  const handleLogout = async () => {
    if (getAuthProvider() === 'azure-ad') {
      await logoutFromMicrosoft();
      return;
    }

    await logoutLocalSession();
  };

  return (
    <DashboardContainer>
      <Header>
        <TitleSection>
          <Logo src={augentLogo} alt="Augent Logo" width="205" />
        </TitleSection>
        <HeaderRight>
          {sessionExpiry && <div>{timeRemaining}</div>}
          <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
        </HeaderRight>
      </Header>

      <Heading>Agentic AI Apps</Heading>

      <POCGrid>
        {config.pocs.map((poc) => (
          <POCCard key={poc.id} poc={poc} />
        ))}
      </POCGrid>
    </DashboardContainer>
  );
};